// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3gpGS","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__Ov_Lk"};